<template>
    <div class="create-modal">
        <div id="create-container">
            <fieldset>
				<legend>Edit Buy-In Offer</legend>
				<p class="yellow-text" style="text-align: center">
					You cannot set the start date to be before the Schedule start.
				</p>
                <div class="label-input">
                    <label>Offer Name</label>
                    <input type="text" id="offerName" :maxlength="maxLengthOfBuyInOffer" v-model="name"/>
                </div>
                <div v-if="playThroughMultiplier <= 0" class="label-input">
                    <label>Regular Credit ({{ systemCurrencyTool.currencyInfo.symbol }}) per
						{{ systemCurrencyTool.formatFromAU(systemCurrencyTool.currencyInfo.auPerCurrencyUnit) }}
						cash</label>
                    <input type="number" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" id="regularCredit" v-model="regularCredit" min="0"/>
					<!-- 69 is the e/E value in unix code -->
					<!-- 189 is the hypen - value in unix code -->
                </div>
				 <div v-else class="label-input">
                    <label>Regular Credit ({{ systemCurrencyTool.currencyInfo.symbol }}) per
						{{ systemCurrencyTool.formatFromAU(systemCurrencyTool.currencyInfo.auPerCurrencyUnit) }}
						cash</label>
                    <input disabled type="number" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" id="regularCredit" v-model="regularCredit" min="0"/>
                </div>
                <div class="label-input">
                    <label>Promo Credit ({{ systemCurrencyTool.currencyInfo.symbol }}) per
						{{ systemCurrencyTool.formatFromAU(systemCurrencyTool.currencyInfo.auPerCurrencyUnit) }}
						cash</label>
                    <input type="number" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" id="promoCredit" v-model="promoCredit" min="0"/>
                </div>
                <div class="label-input">
                    <label>Minimum Cash Buy-In {{ systemCurrencyTool.currencyInfo.symbol }}</label>
                    <input type="number" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" id="minimumCashBuyIn" v-model="minimumCOC" min="0"/>
                </div>
                <div class="label-input">
                    <label>Maximum Cash Buy-In {{ systemCurrencyTool.currencyInfo.symbol }}</label>
                    <input type="number" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" id="maximumCashBuyIn" v-model="maximumCOC" min="0"/>
                </div>
                <div class="label-input">
					<label title="Priority">Priority</label>
					<input type="number" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'" id="priority" name="priority" placeholder="Priority" title="Priority" v-model="priority" min="0"/>
				</div>
                <div class="label-input">
					<label title="Start Date">Start Date</label>
					<input
						type="datetime-local"
						id="start-date"
						placeholder="Start Date"
						title="Start Date"
                        v-model="startDate"
					/>
				</div>
                <div class="label-input">
					<label for="end-date" title="End Date">End Date</label>
					<input
						type="datetime-local"
						id="end-date"
						name="end-date"
						placeholder="End Date"
						title="End Date"
						v-model="endDate"
					/>
				</div>
                <div class="label-input">
					<label for="max-cashin-per-cycle" :title="`Max Cash in per cycle ${systemCurrencyTool.currencyInfo.symbol}`"
						>Max Cash in per cycle {{ systemCurrencyTool.currencyInfo.symbol }}
					</label>
					<input
						type="number"
						id="max-cashin-per-cycle"
						name="max-cashin-per-cycle"
						:title="`max-cashin-per-cycle ${systemCurrencyTool.currencyInfo.symbol}`"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						v-model="maxCashInPerCycle"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="welcome-back-limit-days" title="Welcome Back Limit Days"
						>Welcome Back Limit Days
					</label>
					<input
						type="number"
						id="welcome-back-limit-days"
						name="welcome-back-limit-days"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						title="welcome-back-limit-days"
						v-model="welcomeBackLimitDays"
						min="0"
					/>
				</div>
				<div class="label-input">
					<label for="play-through-multiplier" title="Play Through Multiplier"
						>Play Through Multiplier
					</label>
					<input
						type="number"
						id="play-through-multiplier"
						name="play-through-multiplier"
						onkeydown="return event.keyCode !== 69 && event.keyCode !== 189 && event.key !== '-'"
						title="Play Through Multiplier"
						v-model="playThroughMultiplier"
						min="0"
					/>
				</div>
                <div class="label-input">
					<label for="availableCasinos" title="Available Casinos">Available Casinos</label>
					<select name="available-casino-ids" id="available-casino" v-model="availableCasinoIds" multiple>
						<option v-for="(item,index) in casinoList" :id="item.id" :value="item.id">{{ item.name }}</option>
					</select>
				</div>
                <div v-if="buyIn.schedule != null && !hideBuyinSchedule" class="buyIn-schedule-div">
					<label>Buy-In Schedule</label>
					<textarea id="displayScheduleCreateBuyIn" v-model="buyInSchedule"></textarea>
				</div>
				<div class="label-input">
					<label for="status" title="Status">Status</label>
					<select name="offer-status" v-model="offerStatus">
						<option id="status-active">Active</option>
						<option id="status-inactive">Inactive</option>
						<option id="status-hidden">Hidden</option>
					</select>
				</div>
				<div class="label-input">
					<label for="cashier-allowed" title="Cashier Allowed">Cashier Allowed</label>
					<input
						type="checkbox"
						id="cashier-allowed"
						name="cashier-allowed"
						title="Cashier Allowed"
						v-model="cashierAllowed"
					/>
				</div>
				<div v-if="!disableCreateSchedule" class="label-input">
					<label for="one-claim-per-window" title="Cashier Allowed">One Claim Per Window</label>
					<input
						type="checkbox"
						id="one-claim-per-window"
						name="one-claim-per-window"
						title="One Claim Per Window"
						v-model="oneClaimPerWindow"
					/>
				</div>
				<div class="label-input">
					<label for="web-allowed" title="Web Allowed">Web Allowed</label>
					<input type="checkbox" id="web-allowed" name="web-allowed" title="Web Allowed" v-model="webAllowed"/>
				</div>
				<div class="button-group">
					<button type="button" class="btn" @click="editBuyInOffer()"  title="Create New Casino">Save Buy-In Offer</button>
                    <button type="button" class="btn" @click="closeEditBuyIn()">Close</button>
					<div v-if="!disableCreateSchedule">
						<button type="button" class="btn" @click="createSchedule()">Create Schedule</button>
					</div>
					<!-- <button type="button" class="btn" @click="createSchedule()">Create Schedule</button> -->
				</div>				
			</fieldset>
        </div>
		<transition name="fade">
			<component :is="currentModal" :adminState="adminState"/>
		</transition>
    </div>
</template>

<script>

import { onBeforeUnmount } from "vue";
import Scheduler from "@/components/Scheduler";
import sharedScripts from "@/dependencies/sharedScripts";
export default {
	name: "EditBuyIn",
	components: {
		Scheduler
	},
	props: {
        buyIn: Object,
        systemCurrencyTool: Object,
        casinoList: Object,
        adminState: Object,
		isMobile: Boolean,
	},
	data() {
		return {
            status: Object.assign({}, this.globalStatus),
            scheduleForBuyIn: null,
            offerStatus: null,
            priority: this.buyIn.priority,
            startDate: new Date(this.buyIn.startDate).toISOString().slice(0,16),
            endDate: new Date(this.buyIn.endDate).toISOString().slice(0,16),
            maxCashInPerCycle: this.buyIn.maxCashInPerCycleCOC,
            availableCasinoIds: this.buyIn.availableCasinoIds,
            offerStatus: null,
            cashierAllowed: this.buyIn.cashierAllowed,
            oneClaimPerWindow: this.buyIn.onlyOneClaimPerWindow,
            webAllowed: this.buyIn.webAllowed,
            name:this.buyIn.publicName,
            regularCredit: this.buyIn.creditRegularAUPerCashCOC / this.systemCurrencyTool.currencyInfo.auPerCurrencyUnit,
            promoCredit: this.buyIn.creditPromoAUPerCashCOC / this.systemCurrencyTool.currencyInfo.auPerCurrencyUnit,
            minimumCOC: this.buyIn.minimumCOC,
            maximumCOC:this.buyIn.maximumCOC,
            buyInSchedule: "",
            removeExistingSchedule: false,
            removeExistingMaxCashInPerCycle: false,
			currentModal: null,
            serverBusy: false,
            busyText: "",
			welcomeBackLimitDays: this.buyIn.welcomeBackLimitDays,
			disableCreateSchedule: false,
			hideBuyinSchedule: false,
			playThroughMultiplier: this.buyIn.playthroughMultiplier,

		};
	},
    watch: {
        maxCashInPerCycle() { this.removeExistingMaxCashInPerCycle = true; },

		welcomeBackLimitDays() {
			if(this.welcomeBackLimitDays > 0){
				this.disableCreateSchedule = true;
				this.hideBuyinSchedule = true;
			} 
			else {
				this.disableCreateSchedule = false;
				this.hideBuyinSchedule = false;
			}
		},
		playThroughMultiplier() {
			if(this.playThroughMultiplier > 0) this.regularCredit = 0;
		},

    },
	created() {
		this.eventBus.on("closeSchedulerModal", (serializedData) => {
			this.currentModal = null;
			if(serializedData) document.getElementById("displayScheduleCreateBuyIn").value = serializedData;
			
		});

        this.eventBus.on("createdSchedule", (payload) =>{
			this.removeExistingSchedule = true;
			this.buyIn.schedule = "";
			this.hideBuyinSchedule = false;
			this.scheduleForBuyIn = payload;
		});

		onBeforeUnmount(() => {
			this.eventBus.off("closeSchedulerModal");
		});
	},
	mounted() {
		if(this.buyIn.welcomeBackLimitDays > 0) this.disableCreateSchedule = true;
        this.populateFields();
		if(this.playThroughMultiplier > 0) this.regularCredit = 0;
	},
	methods: {
        closeEditBuyIn() {
            this.eventBus.emit("closeEditOfferModal");
        },

        populateFields() {
            this.casinoList.filter((casino)=>{
                if(this.buyIn.availableCasinoIds.includes(casino.id)){
                    document.getElementById(casino.id).setAttribute('selected', 'selected');
                }
            });

            if(this.buyIn.status == "Active") this.offerStatus = "Active";
            if(this.buyIn.status == "Inactive") this.offerStatus = "Inactive";
            if(this.buyIn.schedule)  this.serializeSchedule();
            
        },

        serializeSchedule() {
            let seralizedSchedule = "Schedule Start: ";
            seralizedSchedule += new Date(this.buyIn.schedule.scheduleStart).toLocaleTimeString([], this.shortDateOptions) + "\n";
            //if(this.buyIn.schedule.cycleDuration[years])
            seralizedSchedule += "Cycle Duration:  ";
			if( this.buyIn.schedule.cycleDuration.years != 0) {
				seralizedSchedule +=  this.buyIn.schedule.cycleDuration.years + "yr"+ "\n";
			}
			if(this.buyIn.schedule.cycleDuration.months != 0){
				 seralizedSchedule += this.buyIn.schedule.cycleDuration.months + "mo"+"\n";
			}
			if(this.buyIn.schedule.cycleDuration.days != 0){
				 seralizedSchedule += this.buyIn.schedule.cycleDuration.days+ "day"+ "\n";
			}
			if(this.buyIn.schedule.cycleDuration.hours != 0){
				 seralizedSchedule += this.buyIn.schedule.cycleDuration.hours+ "hr" +"\n";
			}
			if(this.buyIn.schedule.cycleDuration.minutes != 0){
				 seralizedSchedule += this.buyIn.schedule.cycleDuration.minutes+ "min" + "\n";
			}
			if(this.buyIn.schedule.cycleDuration.excludeDays != 0){
				seralizedSchedule += "\tExcluded Days: " + this.buyIn.schedule.cycleDuration.excludeDays + "\n";
			}
			 
            seralizedSchedule  += "Windows: \n";
            

            //I will need to make a better way to display this, because there could be a lot of windows
            for(let currentWindow = 0; currentWindow < this.buyIn.schedule.windows.length; currentWindow++ ){
                seralizedSchedule += "Window Duration: ";
				if(this.buyIn.schedule.windows[currentWindow].windowDuration.years != 0){
					 seralizedSchedule += this.buyIn.schedule.windows[currentWindow].windowDuration.years + "yr +";
				}
				if(this.buyIn.schedule.windows[currentWindow].windowDuration.months != 0){
					 seralizedSchedule += this.buyIn.schedule.windows[currentWindow].windowDuration.months +"mo +";
				}
				if(this.buyIn.schedule.windows[currentWindow].windowDuration.days != 0) {
					  seralizedSchedule += this.buyIn.schedule.windows[currentWindow].windowDuration.days +"day +";
				}
				if( this.buyIn.schedule.windows[currentWindow].windowDuration.hours != 0) {
					 seralizedSchedule += this.buyIn.schedule.windows[currentWindow].windowDuration.hours +"hr +";
				}
				if(this.buyIn.schedule.windows[currentWindow].windowDuration.minutes != 0) {
					 seralizedSchedule += this.buyIn.schedule.windows[currentWindow].windowDuration.minutes +"min";
				}

				if(seralizedSchedule[seralizedSchedule.length -1] == "+") seralizedSchedule = seralizedSchedule.slice(0,-1);
			
               
                seralizedSchedule+= "\nWindow Start: ";
				let seralizedWindowStart = "";
				if(this.buyIn.schedule.windows[currentWindow].windowStart.years != 0){
					seralizedWindowStart += this.buyIn.schedule.windows[currentWindow].windowStart.years + "yr +";
				}
                if(this.buyIn.schedule.windows[currentWindow].windowStart.months != 0) {
					seralizedWindowStart += this.buyIn.schedule.windows[currentWindow].windowStart.months + "mo +";
				}
				if(this.buyIn.schedule.windows[currentWindow].windowStart.days != 0) {
					seralizedWindowStart += this.buyIn.schedule.windows[currentWindow].windowStart.days + "day +";
				}
				if(this.buyIn.schedule.windows[currentWindow].windowStart.hours != 0){
					seralizedWindowStart += this.buyIn.schedule.windows[currentWindow].windowStart.hours + "hr +";
				}
				if(this.buyIn.schedule.windows[currentWindow].windowStart.minutes != 0) {
					seralizedWindowStart += this.buyIn.schedule.windows[currentWindow].windowStart.minutes + "min";
				}
				
				if(seralizedWindowStart[seralizedWindowStart.length -1] == "+") seralizedWindowStart = seralizedWindowStart.slice(0,-1);
				if(seralizedWindowStart== "") seralizedWindowStart = "Started Immediately"

				seralizedWindowStart += "\n";
				seralizedSchedule += seralizedWindowStart;

            }
            this.buyInSchedule = seralizedSchedule;
            
        },

        async editBuyInOffer() {
			if(this.name > this.maxLengthOfBuyInOffer){
				this.status.code = "Offer name cannot be longer than 64 characters";
                this.status.ok = false;
                this.eventBus.emit("updateStatus", this.status);
			}
			if(this.startDate < this.scheduleForBuyIn?.scheduleStart || this.startDate < this.buyIn.schedule?.scheduleStart) {
				this.status.message = "Start Date cannot be before schedule start";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}

			let isPlayThroughMultiplierDecimalValue = (this.playThroughMultiplier - Math.floor(this.playThroughMultiplier)) !== 0;
			let isWelcomeBackLimitDaysDecimalValue = (this.welcomeBackLimitDays - Math.floor(this.welcomeBackLimitDays)) !== 0;

			switch (true) {
				case !this.name:
					this.status.message = "Buy-in offer must have a name.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.regularCashCOC < 0:
					this.status.message = "Regular Au per cash unit cannot be a negative number.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.promoCashCOC < 0:
					this.status.message = "Promo Au per cash unit cannot be a negative number.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case !this.minimumCOC > 0 || !this.maximumCOC > 0:
					this.status.message = "Minimum and maximum must be greater than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.minimumCOC < 0 || this.maximumCOC < 0:
					this.status.message = "Minimum and maximum cannot be less than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case !this.priority > 0:
					this.status.message = "Priority must be greater than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.priority < 0:
					this.status.message = "Priority cannot be less than 0.";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.welcomeBackLimitDays < 0:
					this.status.message = "Welcome Back Limit Days cannot be less than 0";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case this.playThroughMultiplier < 0:
					this.status.message = "Play Through Multiplier cannot be less than 0";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case isPlayThroughMultiplierDecimalValue:
					this.status.message = "Play Through Multiplier must be a whole number (no decimal allowed)";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				case isWelcomeBackLimitDaysDecimalValue:
					this.status.message = "Welcome Back Limit Days must be a whole number (no decimals allowed)";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
			}
            let body = {
				BuyInOffer: this.createBuyInOfferConfig(),
			    RemoveExistingSchedule: this.removeExistingSchedule ? true : false ,
				RemoveExistingMaxCashInPerCycle: this.removeExistingMaxCashInPerCycle ? true : false,
			};

			let requestUrl = new URL("/api/v1/offer/update/", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

            try{
                let response = await fetch(request);

                let fetchStatus = sharedScripts.checkFetchErrors(response);

                if(fetchStatus && !fetchStatus.ok){
                    this.serverBusy = false;
                    this.busyText = "";
                    this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
                    return false;
                }
                let dataJson = await response.json();
                this.status.message = `${dataJson.buyInOffer.publicName} has been Edited.`;
                this.status.code = fetchStatus.code;
                this.status.ok = fetchStatus.ok;
                this.eventBus.emit("updateStatus", this.status);
                this.closeEditBuyIn();
            }
            catch(e){
                console.log("this is the error", e);
                this.status.code = e;
                this.status.ok = false;
                this.eventBus.emit("updateStatus", this.status);
                return false;
            }
        },

		createSchedule() {
			this.currentModal = "Scheduler";
		},

        createBuyInOfferConfig() {
			let buyInOfferConfig = {};
            buyInOfferConfig.Id = this.buyIn.id;
			buyInOfferConfig.AdminName = this.adminState.displayName;
			buyInOfferConfig.PublicName = this.name;
			buyInOfferConfig.CreditRegularAUPerCashCOC = this.regularCredit * this.systemCurrencyTool.currencyInfo.auPerCurrencyUnit;
			buyInOfferConfig.CreditPromoAUPerCashCOC = this.promoCredit * this.systemCurrencyTool.currencyInfo.auPerCurrencyUnit;
			buyInOfferConfig.MinimumCOC = this.minimumCOC;
			buyInOfferConfig.MaximumCOC = this.maximumCOC;
			buyInOfferConfig.StartDate = this.startDate ? this.formatDateTimeISOString(this.startDate, false) : null;
			buyInOfferConfig.EndDate = this.endDate ? this.formatDateTimeISOString(this.endDate, false) : null;
			buyInOfferConfig.Priority = this.priority;
			buyInOfferConfig.CashierAllowed = this.cashierAllowed;
			buyInOfferConfig.WebAllowed = this.webAllowed;
			buyInOfferConfig.Status = this.offerStatus; 
			if(!this.disableCreateSchedule) {
				 buyInOfferConfig.Schedule = this.removeExistingSchedule ? this.scheduleForBuyIn : this.buyIn.schedule; 
			}
			else{
				buyInOfferConfig.Schedule = null;
				this.removeExistingSchedule = true;
			}
			buyInOfferConfig.OnlyOneClaimPerWindow = this.oneClaimPerWindow;
            buyInOfferConfig.MaxCashInPerCycleCOC = this.removeExistingMaxCashInPerCycle ?  this.maxCashInPerCycle  : this.buyIn.maxCashInPerCycleCOC;
			buyInOfferConfig.AvailableCasinoIds = this.availableCasinoIds;
			buyInOfferConfig.WelcomeBackLimitDays = this.disableCreateSchedule ? this.welcomeBackLimitDays : 0 ;
			buyInOfferConfig.PlayThroughMultiplier = this.playThroughMultiplier;

			if(buyInOfferConfig.MaxCashInPerCycleCOC == "") buyInOfferConfig.MaxCashInPerCycleCOC = null;
			return buyInOfferConfig;
		},
    }
};
</script>

<style scoped>

.create-modal {
	position: fixed;
	display: grid;
	height: 100vh;
	top: 0;
	right: 0;
	bottom: 0;
	left: 20%;
	background-color: rgb(0 0 0 / 75%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
	z-index: 1;
}
.create-modal-mobile {
	position: fixed;
	display: grid;
	height: 100vh;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: rgb(0 0 0 / 75%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
	z-index: 1;
}

#create-container {
	display: flex;
	flex-flow: column nowrap;
	position: relative;
	top: 15px;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #222;
	color: #fff;
	width: 90%;
	margin: auto;
	padding: 30px;
	border-radius: 12px;
	text-align: center;
	overflow-y: scroll;
	height: 75vh;
}

.label-input {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
}

.label-input label,
.input-group .playable-label {
	max-width: 10em;
	flex: 0 1 auto;
	text-align: right;
}

.buyIn-schedule-div {
    display: flex;
    flex-direction: column;
    align-items: center;
}

textarea {
    width: 32vw;
    height: 10vh;
}
.button-group {
	display: inline-flex;
}

@media (max-width: 768px) {
	.create-modal {
		left: 0%;
	}
	
	.label-input {
		display: grid;
		justify-content: center;
	}
}

</style>